export * from './web3'

// TODO: remove shared folder, make specific folder for each business context
